import { Button } from '@mui/material'
import React, { useEffect } from 'react'
import {
  type CurrencyExchangeInstructionBatchDetails
} from '../../../../api-schema-types/financial/CurrencyExchangeDomainDtos'
import { useUnlinkExchangeInstructionsMutation } from '../../../../api-services/financial/currencyExchangeApi'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import { setUnlinkActions } from './exchangeInstructionsSlice'

interface UnlinkInstructionsProps {
  batch: CurrencyExchangeInstructionBatchDetails
  instructionIds: number[]
}
const UnlinkInstructions: React.FC<UnlinkInstructionsProps> = ({ batch, instructionIds }: UnlinkInstructionsProps) => {
  const dispatch = useAppDispatch()

  const [apiUnlinkInstructionsTrigger, apiUnlinkInstructionsResult] = useUnlinkExchangeInstructionsMutation()
  const handleUnlinkInstructions = async (): Promise<void> => {
    const choice = window.confirm(
      'Are you sure you want to unlink instructions from this batch?'
    )
    if (choice) {
      await apiUnlinkInstructionsTrigger({ batchId: batch.batchId, instructionIds })
    }
  }

  useEffect(() => {
    if (apiUnlinkInstructionsResult.isSuccess) {
      dispatch(setNotification({
        open: true,
        severity: 'success',
        message: `${instructionIds.length} instructions unlinked from batch ${apiUnlinkInstructionsResult.data.batchId}.`
      }))
      dispatch(setUnlinkActions([]))
    }

    if (apiUnlinkInstructionsResult.isError) {
      dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(apiUnlinkInstructionsResult.error) }))
    }
  }, [apiUnlinkInstructionsResult.isSuccess, apiUnlinkInstructionsResult.isError])

  return (
    <>
      <Button type={'button'} variant={'contained'} color={'warning'}
              sx={{ mr: 2 }}
              disabled={!(batch.canUnlinkInstructions && instructionIds.length > 0)}
              onClick={handleUnlinkInstructions}>
        Unlink Selected Instructions
      </Button>
    </>
  )
}

export default UnlinkInstructions
